import React from 'react';

export type StatusPillVariant = 'live' | 'expire' | 'neutral';

export type StatusPillProps = {
  variant: StatusPillVariant;
  label: string;
  className?: string;
};

const VARIANT_CLASS: Record<StatusPillVariant, string> = {
  live: 'bg-stream-live text-white',
  expire: 'bg-stream-expire text-stream-expire-ink',
  neutral: 'bg-stream-raised text-stream-ink',
};

const StatusPill: React.FC<StatusPillProps> = ({ variant, label, className }) => (
  <span
    data-testid={`status-pill-${variant}`}
    className={`inline-flex items-center gap-1 rounded-stream-sm px-2 py-0.5 font-stream-body text-xs font-semibold uppercase tracking-wide ${VARIANT_CLASS[variant]}${className ? ` ${className}` : ''}`}
  >
    {variant === 'live' ? (
      <span className="h-1.5 w-1.5 rounded-full bg-white" data-testid="status-pill-live-dot" aria-hidden="true" />
    ) : null}
    {label}
  </span>
);

export default StatusPill;
